import { Expose } from 'class-transformer';
import { DropdownModel } from './dropdown-model';
import { Constants } from '../../common';
import { getCookie } from 'src/app/shared/helper';

export class Program extends DropdownModel {
  @Expose() id: string;       // focus on it
  @Expose() fullName: string;

  override get dropDownDisplayName(): string {
    return this.fullName;
  }
  override get dropDownValue(): Object {
    return this;
  }

  constructor() {
    super();
  }
}
